let partners = [
  {
      name: "partners.gold",
      content: [
          {
              name: "Iss",
              logo: require("@/assets/images/parteners/iss.png"),
              link: ""
          },
          {
              name: "Adfaber",
              logo: require("@/assets/images/parteners/logoadfaber.png"),
              link: ""
          }
      ]
  },
  {
      name: "partners.silver",
      content: [
          {
              name: "Credis",
              logo: require("@/assets/images/parteners/iss.png"),
              link: "https://www.academiacredis.ro/"
          }
      ]
  },
  {
      name: "partners.annual",
      content: [
          {
              name: "EESTEC Soft Skills Academy",
              logo: require("@/assets/images/parteners/iss.png"),
              link: ""
          }
      ]
  },
  {
      name: "partners.academic",
      content: [
          {
              name: "Bogdan Gribincea",
              logo: require("@/assets/images/parteners/iss.png"),
              link: ""
          },
          {
              name: "SoftVenture",
              logo: require("@/assets/images/parteners/iss.png"),
              link: ""
          },
          {
              name: "Enel",
              logo: require("@/assets/images/parteners/iss.png"),
              link: ""
          },
          {
              name: "Rubicle",
              logo: require("@/assets/images/parteners/iss.png"),
              link: ""
          },
          {
              name: "UBP",
              logo: require("@/assets/images/parteners/iss.png"),
              link: ""
          }
      ]
  },
  {
      name: "partners.media",
      content: [
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },
          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          },          {
            name: "Buzzcamp",
            logo: require("@/assets/images/parteners/iss.png"),
            link: "http://buzzcamp.ro"
          }
        ]
    }
]

export default partners;